import { applyMiddleware, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import { persistStore, persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";

import reducersSchema from "./reducers/schema";
import { authConstants } from "./actions/auth/index";

const logger = createLogger({ collapsed: true });

const config = {
  key: "primary",
  storage,
  /** Persistere altro oltre ad auth da inconsistenze quando si clicca il link per il portale */
  whitelist: ["auth", "main", "company"/* , "connections", "currentPermissions", "sso", "documentsWithSearch",  "user", "featureFlags"*/] 
};

const persistedReducer = persistCombineReducers(config, reducersSchema);

const reducers = (state, action) => {
  // on logout, resets the redux state to its default
  if (action.type === authConstants.LOGIN_RESET) {
    state = undefined;
  }

  return persistedReducer(state, action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk, logger)));

persistStore(store);

export default store;
